import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import domain from '../../constants/config.js';
import { aesEncrypt, getOSType } from './../../utils/Common.js';

const apiDomain = domain.LOGIN_API_BASE_URL;

export const OtpAuthenticate = createAsyncThunk(
  'OtpAuthenticateList/OtpAuthenticate',
  async (requestData) => {
    try {
        
        const encryptedToken = aesEncrypt(requestData.mobile_number);
        console.log('Encrypted token=========:', encryptedToken);

        const headers = {
            'X-Source-Type': getOSType(),
            'Authorization': encryptedToken,
            'Content-Type': 'application/json', // optional, but good to include
        };

        console.log('headers =========:', headers);
        const apiUrl = `${apiDomain}v1/authentication-code`;
        const response = await axios.post(apiUrl,requestData,{headers});
        console.log("API OtpAuthenticate Response:", response.data);

      return response.data;
    } catch (error) {
      console.error("API Error in OtpAuthenticate:", error);
      throw error;
    }
  }
);

export const OtpVerify = createAsyncThunk(
    'OtpAuthenticateList/OtpVerify',
    async (requestData) => {
      try {
  
        const apiUrl = `${apiDomain}v5/verification-code/verify`;
        const response = await axios.post(apiUrl,requestData);
        console.log("API OtpVerify Response:", response.data);
  
        return response.data;
      } catch (error) {
        console.error("API Error in OtpVerify:", error);
        throw error;
      }
    }
  );


const OtpAuthenticateSlice = createSlice({

  name: 'OtpAuthenticateList',
  initialState: {
    apiResponse: [],
    loading: false,
    apiErrorMsg: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(OtpAuthenticate.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
      })
      .addCase(OtpAuthenticate.fulfilled, (state, action) => {
        state.loading = false;
        state.apiResponse = action.payload; //API call completes → fulfilled sets list = response.data
        console.log("Reducer OtpAuthenticate apiResponse",state.apiResponse);
      })
      .addCase(OtpAuthenticate.rejected, (state, action) => {
        state.loading = false;
        state.apiErrorMsg = action.error.message; // If it fails → rejected sets error = message
      })
      .addCase(OtpVerify.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
      })
      .addCase(OtpVerify.fulfilled, (state, action) => {
        state.loading = false;
        state.apiResponse = action.payload; //API call completes → fulfilled sets list = response.data
        console.log("Reducer OtpVerify apiResponse",state.apiResponse);
      })
      .addCase(OtpVerify.rejected, (state, action) => {
        state.loading = false;
        state.apiErrorMsg = action.error.message; // If it fails → rejected sets error = message
      });
  },
});

export default OtpAuthenticateSlice.reducer;
